/** @jsx jsx */
import { jsx } from "theme-ui"
import RecentlyViewed from "../recently-viewed"

const RecentlyViewedPattern = ({ blade }) => {
  return <RecentlyViewed />
}

export default RecentlyViewedPattern
